import styled from "styled-components";

export const SwitchWrapperSC = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px 0;
`;
